import { Button } from "antd";
import React from "react";
import { MdFavoriteBorder } from "react-icons/md";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { RiListUnordered } from "react-icons/ri";
import { PiAddressBook } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FiUser } from "react-icons/fi";
import { clearCart } from "../../../redux/slices/cartSlice";
import { logout } from "../../../redux/slices/userSlice";
import { Link } from "react-router-dom";
import { clearStore } from "../../../redux/slices/storeSlice";
import { logoutChannel } from "../../../logout";
import { useTranslation } from "react-i18next";
import "./style.scss"
const ProfileMenu = (props: any) => {
  const { t } = useTranslation();
  const navigation = useNavigate();
  const Auth = useSelector((state: any) => state.User);
  const User = useSelector((state: any) => state.User.user);
  const dispatch = useDispatch();

  const OpenLink = (link: any) => {
    if (Auth.auth) {
      navigation(link);
    } else {
      navigation("/login");
    }
  };

  const logotFunction = () => {
    if (Auth.auth) {
      logoutChannel.postMessage("Logout");
      dispatch(logout(null));
      dispatch(clearCart(null));
      dispatch(clearStore(null));
      navigation("/");
      props.close();
    } else {
      navigation("/login");
      props.close();
    }
  };

  return (
    <div className="profileMenu-Box1">
      <div className="profileMenu-Icon">
          {User?.data?.image ? (
            <img
              src={User?.data?.image}
              className="Header-ProfileImag"
              alt="profile"
            />
          ) : (
            <HiOutlineUserCircle size={45} color="#B1004B" />
          )}
        <div style={{ marginTop: 5,marginBottom:5, fontWeight: "900" }}>
          {User?.data?.first_name
            ? User.data?.first_name
            : User.data?.data?.first_name || `${t("Guest_User")}`}
        </div>
      </div>

      {Auth.auth && (
        <>
          <div
            className="profileMenu-Box2"
            onClick={() => {
              OpenLink("/profile/home");
              props.close();
            }}
          >
            <div>
              <FiUser size={20} className="profileMenu-Img1" />
            </div>
            <div className="profileMenu-Txt1">Profile</div>
          </div>
          <div
            className="profileMenu-Box2"
            onClick={() => {
              OpenLink("/profile/orders");
              props.close();
            }}
          >
            <div>
              <RiListUnordered size={20} className="profileMenu-Img1" />
            </div>
            <div className="profileMenu-Txt1">Orders</div>
          </div>
          <div
            className="profileMenu-Box2"
            onClick={() => {
              OpenLink("/profile/favourites");
              props.close();
            }}
          >
            <div>
              <MdFavoriteBorder size={20} className="profileMenu-Img1" />
            </div>
            <div className="profileMenu-Txt1">Favorites</div>
          </div>
          <div
            className="profileMenu-Box2"
            onClick={() => {
              OpenLink("/profile/address");
              props.close();
            }}
          >
            <div>
              <PiAddressBook size={20} className="profileMenu-Img1" />
            </div>
            <div className="profileMenu-Txt1">Address</div>
          </div>
        </>
      )}
      <div style={{ margin: 5 }} />
      
      <Button size="large" type="primary" block onClick={() => logotFunction()}>
        {Auth.auth ? "Logout" : `${t("Login")}`}
      </Button>
      {Auth.auth ? null : (
        <div style={{ marginTop: "10px" }}>
          {t("New_Customer?")} &nbsp;&nbsp;
          <Link
            to="signup/user"
            onClick={() => {
              if (typeof props.close == "function") {
                props.close();
              }
            }}
          >
            <a href="">{t("Sign_Up")}</a>
          </Link>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
